import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logoBoA.svg'
import { FormattedMessage } from 'react-intl';


const Footer = (props) => (
    <footer className="footer">
        <div className="columns has-text-centered">
            <div className="column is-half is-offset-one-quarter">
                <p>
                    <Link to={props.locale + '/'}>
                        <img src={logo} alt="BoA" style={{ width: '50px' }} />
                    </Link>
                </p>
                <div className="columns is-mobile">
                    <div className="column">
                        <p><Link to={props.locale + '/boa'}><FormattedMessage id="navBoaSoftware" /></Link></p>
                        <hr/>
                        <p><Link to={props.locale + '/boa/characteristics'}><FormattedMessage id="navCharacteristics" /></Link></p>
                        <p><Link to={props.locale + '/boa/compatibility'}><FormattedMessage id="navCompatibility" /></Link></p>
                        <p><Link to={props.locale + '/boa/downloads'}><FormattedMessage id="navDownloads" /></Link></p>
                    </div>
                    <div className="column">
                        <p><Link to={props.locale + '/versions'}><FormattedMessage id="navVersions" /></Link></p>
                        <hr/>
                        <p><Link to={props.locale + '/versions/boa-4_2'}><FormattedMessage id="navBoA-4_2" /></Link></p>
                        <p><Link to={props.locale + '/versions/4_2-4_3'}><FormattedMessage id="nav4_2-4_3" /></Link></p>
                        <p><Link to={props.locale + '/versions/boa-4_3'}><FormattedMessage id="navBoA-4_3" /></Link></p>
                        <p><Link to={props.locale + '/versions/boa-4_3-localized'}><FormattedMessage id="navBoA-4_3Localized" /></Link></p>
                        <p><Link to={props.locale + '/versions/boa-4_4'}><FormattedMessage id="navBoA-4_4" /></Link></p>
                    </div>
                    <div className="column">
                        <p><Link to={props.locale + '/documentation'}><FormattedMessage id="navDocumentation" /></Link></p>
                        <hr/>
                        <p><Link to={props.locale + '/documentation/tutorials'}><FormattedMessage id="navTutorials" /></Link></p>
                        <p><Link to={props.locale + '/documentation/images'}><FormattedMessage id="navImages" /></Link></p>
                        <p><Link to={props.locale + '/documentation/hatching'}><FormattedMessage id="navHatching" /></Link></p>
                    </div>
                </div>
                <p>
                    <Link to={props.locale + '/pricing'}><FormattedMessage id="navPricing" /></Link>
                    &nbsp;<span className="grey-pipe">|</span>&nbsp;
                    <Link to={props.locale + '/contact'}><FormattedMessage id="navContact" /></Link>
                    &nbsp;<span className="grey-pipe">|</span>&nbsp;
                    <a href="http://forum.boa-research.fr/" target="_blank" rel="noopener noreferrer"><FormattedMessage id="navForum" /></a>
                    &nbsp;<span className="grey-pipe">|</span>&nbsp;
                    <Link to={props.locale + '/links'}><FormattedMessage id="navLinks" /></Link>
                </p>
                <p>BoA Research SARL &copy; 2018</p>
            </div>
        </div>
  </footer>
)

export default Footer